import { AUTHENTICATION_START, AUTHENTICATION_REFRESH, AUTHENTICATION_SUCCESS, AUTHENTICATION_FAILED, AUTHENTICATION_ANONYMOUS_LOGIN_START, AUTHENTICATION_ANONYMOUS_LOGIN_SUCCESS, AUTHENTICATION_ANONYMOUS_LOGIN_FAILED, AUTHENTICATION_LOGOUT_START, AUTHENTICATION_LOGOUT_FAILED, AUTHENTICATION_LOGOUT_SUCCESS, AUTHENTICATION_EXPIRED, } from './constants.js';
import { config } from './config.js';
const isAnonymousToken = (parsedAccessToken) => parsedAccessToken?.payload.preferred_username === 'anonymous';
export const auth = (state = config.initialState, action) => {
    switch (action.type) {
        case AUTHENTICATION_START: {
            return { ...state, isPending: true, error: null };
        }
        case AUTHENTICATION_REFRESH: {
            const isAnonymous = isAnonymousToken(action.payload.parsedAccessToken);
            return {
                ...state,
                ...action.payload,
                isLoggedIn: !isAnonymous,
                isAnonymous,
                hasExpiredLogin: false,
            };
        }
        case AUTHENTICATION_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isPending: false,
                isLoggedIn: true,
                hasExpiredLogin: false,
                error: null,
            };
        }
        case AUTHENTICATION_FAILED: {
            return {
                ...state,
                isPending: false,
                isLoggedIn: false,
                hasExpiredLogin: false,
                parsedAccessToken: null,
                error: action.payload || 'Authentication Failed',
            };
        }
        case AUTHENTICATION_ANONYMOUS_LOGIN_START: {
            return {
                ...state,
                isPending: true,
                isLoggedIn: false,
                isAnonymous: false,
                hasExpiredLogin: false,
                error: null,
            };
        }
        case AUTHENTICATION_ANONYMOUS_LOGIN_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isPending: false,
                isLoggedIn: false,
                isAnonymous: true,
                hasExpiredLogin: false,
                error: null,
            };
        }
        case AUTHENTICATION_ANONYMOUS_LOGIN_FAILED: {
            return {
                ...config.initialState,
                error: action.payload || 'Anonymous Authentication Failed',
            };
        }
        case AUTHENTICATION_LOGOUT_START: {
            return {
                ...state,
                isPending: true,
                hasExpiredLogin: false,
                error: null,
            };
        }
        case AUTHENTICATION_LOGOUT_SUCCESS:
        case AUTHENTICATION_LOGOUT_FAILED: {
            return {
                ...config.initialState,
                ...action.payload,
            };
        }
        case AUTHENTICATION_EXPIRED: {
            return {
                ...state,
                hasExpiredLogin: true,
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map